import { GET_CURRENCY_CALCULATIONS } from 'framework/base/constants/aryGraphqlSchemas';
import { useAryLazyQuery } from 'framework/base/hooks/useAryGraphql';
import { useEffect, useState } from 'react';

const useAryCurrencyManagement = ({
  sourceCurrencyCode,
  destinationCurrencyCode
}) => {
  const [calculationRate, setCalculationRate] = useState('');
  const [isDivision, setIsDivision] = useState('');

  const [getCurrencyCalculations, { data: getCurrencyCalculationsQueryData }] =
    useAryLazyQuery({
      gqlConfig: GET_CURRENCY_CALCULATIONS,
      items: `
        currencyCalculations {
          sourceCurrencyCode
          destinationCurrencyCode
          calculationRate
        }
      `
    });

  function getCurrentCalculationRateAndIsDivision() {
    const sourceToDestCalc =
      getCurrencyCalculationsQueryData?.currencyCalculations.find(
        (obj) =>
          obj.sourceCurrencyCode === sourceCurrencyCode &&
          obj.destinationCurrencyCode === destinationCurrencyCode
      )?.calculationRate;
    if (sourceToDestCalc !== undefined) {
      setCalculationRate(sourceToDestCalc);
      setIsDivision(false);
      return [sourceToDestCalc, false];
    }
    const destToSourceCalc =
      getCurrencyCalculationsQueryData?.currencyCalculations.find(
        (obj) =>
          obj.sourceCurrencyCode === destinationCurrencyCode &&
          obj.destinationCurrencyCode === sourceCurrencyCode
      )?.calculationRate;
    if (destToSourceCalc !== undefined) {
      setCalculationRate(destToSourceCalc);
      setIsDivision(true);
      return [destToSourceCalc, true];
    }
    setCalculationRate(0);
    setIsDivision('');
    return [0, ''];
  }

  useEffect(() => {
    getCurrencyCalculations({
      pagination: { pageIndex: 0, pageCount: 100000 }
    });
  }, []);

  useEffect(() => {
    if (
      getCurrencyCalculationsQueryData &&
      sourceCurrencyCode &&
      destinationCurrencyCode
    ) {
      getCurrentCalculationRateAndIsDivision();
    }
  }, [
    getCurrencyCalculationsQueryData,
    sourceCurrencyCode,
    destinationCurrencyCode
  ]);

  return [calculationRate, isDivision, getCurrentCalculationRateAndIsDivision];
};

export default useAryCurrencyManagement;
